module.exports = __webpack_public_path__ + "img/combo.d4eb2a1a.png";